<template>
  <div
    itemscope
    itemtype="http://schema.org/Product"
    class="perfume-card"
    @click="$emit('click', data)"
  >
    <div
      class="image"
      :style="{ backgroundImage: `url(${data.imageUrl})` }"
    ></div>
    <div v-if="data.brand" itemprop="brand" class="brand">{{ data.brand.name }}</div>
    <div itemprop="name" class="name">{{ data.name }}</div>
    <FamiliesWithIcon
      itemprop="additionalProperty"
      :family="data.family"
      :subfamily="data.secondaryFamily"
    ></FamiliesWithIcon>
    <div
      class="remove-button"
      v-if="showRemove"
      @click.stop="$emit('remove', data)"
    ></div>
  </div>
</template>

<script>
import FamiliesWithIcon from "@/components/FamiliesWithIcon";
export default {
  name: "PerfumeCard",
  components: {
    FamiliesWithIcon,
  },
  props: ["data", "showRemove"],
  methods: {},
};
</script>

<style scoped lang="stylus">
.perfume-card
  position: relative
  display: flex
  flex-direction: column
  align-items: center
  overflow: hidden
  padding: vw(30px)
  background-color: #fff
  cursor: pointer

  .image
    flex: 1 1 0%
    margin-bottom: vw(30px)
    width: 100%
    background-position: center center
    background-size: contain
    background-repeat: no-repeat

  .brand
    m-ellipsis(100%)
    m-font-size(14, 14)
    m-letter-spacing(20)
    align-self: flex-start

  .name
    m-ellipsis(100%)
    m-font-size(20, 30)
    align-self: flex-start
    font-weight: 600

  .remove-button
    m-icon("close", 15)
    position: absolute
    right: vw(4px)
    cursor: pointer

  .family-and-icon
    margin-top: vw(10px)
    width: 100%
</style>